export default __webpack_public_path__ + "static/media/vn.5e8684f5.svg";